



/**
 * Send phonenumber to analytic's datalayer
 * @param {string} phoneNumber phonenumbers
 */
function sendPhoneClick(phoneNumber) {
  window.dataLayer.push({
    'event': 'GAEvent',
    'eventCategory': 'OmaLaakkonen',
    'eventAction': 'DirectCall',
    'eventLabel': phoneNumber,
    'eventNonInteraction': 'false'
  });
}

/**
 * Send maintanance click to analytic's datalayer
 * @param {string} path path
 */
function sendMaintenanceClick(path) {
  window.dataLayer.push({
    'event': 'GAEvent',
    'eventCategory': 'OmaLaakkonen',
    'eventAction': 'ServiceReservation',
    'eventLabel': path,
    'eventNonInteraction': 'false'
  });
}


module.exports = {
  sendPhoneClick,
  sendMaintenanceClick
};
